export const text = {
  PHONE_NUMBER_LOWER: 'phone number',
  PHONE_NUMBER: 'Phone number',
}
export const styles = {
  COUNTRY_PICKER_BUTTON_STYLE: {
    border: 'none',
    borderRadius: '4px 0 0 4px',
    backgroundColor: '#eff3f6',
  },
  COUNTRY_PICKER_CONTAINER_STYLE: {
    backgroundColor: 'transparent',
  },
  COUNTRY_PICKER_DROPDOWN_STYLE: {
    background: '#eff3f6',
    fontFamily: 'Helvetica',
    fontWeight: '400',
    fontSize: 16,
    width: 603,
  },
  COUNTRY_PICKER_INPUT_STYLE: {
    height: 60,
    border: 'none',
    borderRadius: 0,
    background: 'transparent',
    paddingLeft: 0,
    color: 'transparent',
  },
}

export const apiErrorCodes = {
  PHONE_NUMBER_NOT_VALID: 'PhoneNumberNotValid',
  PHONE_NUMBER_NOT_UNIQUE: 'PhoneNumberNotUnique',
  THIRD_PARTY_ERROR: 'ThirdPartyError',
  FORBIDDEN: 'Forbidden',
}

export const tabNames = {
  GENERAL: 'General',
  LICENSE_AND_PRODUCTIVITY: 'Licenses & Productivity',
  CALENDAR: 'Calendar',
}

export const userManagementTypes = {
  PROVIDER: 'Provider',
  ADMIN: 'Admin',
}
export const visibilityTypes = {
  allPatients: { displayName: 'All patients', name: 'all' },
  noBookings: { displayName: 'No bookings', name: 'none' },
  repeatPatients: { displayName: 'Repeat patients', name: 'repeat' },
}
export function getVisibilityType(name: string): (typeof visibilityTypes)[keyof typeof visibilityTypes] {
  if (name === visibilityTypes.repeatPatients.displayName || name === visibilityTypes.repeatPatients.name)
    return visibilityTypes.repeatPatients
  if (name === visibilityTypes.noBookings.displayName || name === visibilityTypes.noBookings.name)
    return visibilityTypes.noBookings
  return visibilityTypes.allPatients
}
